import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { SellerAccountClient } from 'src/WebApiController';

export function useSyncCenterSettings() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();

  const query = useQuery({
    queryKey: [
      'getSyncCenterSettings',
      activeAccountWebClientConfig.activeAccountId,
    ],
    queryFn: () => {
      if (activeAccountWebClientConfig.activeAccountId == null) {
        return null;
      }
      return new SellerAccountClient(
        activeAccountWebClientConfig
      ).getSyncCenterSettings();
    },

    enabled: activeAccountWebClientConfig.activeAccountId != null,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    meta: {
      onError: (error: ErrorTypes) => {
        showErrorDialog('SellerAccountClient.getSyncCenterSettings', error);
      },
    },
  });

  return query;
}
